<div class="my-3">
  @if (viewItemInfo) {
    <div>
      <p><strong>History ID:</strong> {{ viewItemInfo.id }}</p>
      <p><strong>Edit by:</strong> {{ viewItemInfo.userId }}</p>
      <p><strong>Edit date:</strong> {{ viewItemInfo.dateUpdated }}</p>
      <p><strong>Content Type:</strong> {{ viewItemInfo.type }}</p>
      @if (viewItemInfo.name) {
        <p><strong>Name:</strong> {{ viewItemInfo.name }}</p>
      }
    </div>
    <div>
      <span><strong>Content:</strong></span>
      <pre>{{ viewItemInfo.content }}</pre>
    </div>
  }
</div>
